// extracted by mini-css-extract-plugin
export default {"topTip":"src-pages-Settings-3rdPartyApi-css-module__topTip--3pbiF"};